export class mdlAddAdditionalCovers{
    public ProposalNo: string;
    public ProductCode: string;
    public Covers:Array<mdlCovers>=new Array<mdlCovers>();    
}

export class mdlCovers
{
    public  CoverCode:string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlAddAdditionalCovers.ts